import React from 'react';
import {View, Image, Text, StyleSheet, TouchableOpacity} from 'react-native';
import {goTo, useResponsiveDimensions} from '@/utils';
import {useSequentialModalContext} from '@/components/basic/sequential-modal/context';
// Image imports
const btnImg = require('@assets/imgs/yue/btn.png');
const basicImg = require('@assets/imgs/yue/img.png');
const tip = require('@assets/imgs/yue/tip.png');
const close = require('@assets/imgs/yue/close.png');
const currency = require('@assets/imgs/yue/currency.png');
import {useScreenSize} from '@/common-pages/hooks/size.hooks';
// 数字图片导入
// type DigitKey = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';
export type DigitKey = {
  [k: string | number]: any;
};

const digitImages: DigitKey = {
  '0': require('@assets/imgs/yue/0.png'),
  '1': require('@assets/imgs/yue/1.png'),
  '2': require('@assets/imgs/yue/2.png'),
  '3': require('@assets/imgs/yue/3.png'),
  '4': require('@assets/imgs/yue/4.png'),
  '5': require('@assets/imgs/yue/5.png'),
  '6': require('@assets/imgs/yue/6.png'),
  '7': require('@assets/imgs/yue/7.png'),
  '8': require('@assets/imgs/yue/8.png'),
  '9': require('@assets/imgs/yue/9.png'),
};
const stageImages: DigitKey = {
  1: require('@assets/imgs/yue/text1.png'),
  2: require('@assets/imgs/yue/text2.png'),
  3: require('@assets/imgs/yue/text3.png'),
};

const STEP_TEXTS: DigitKey = {
  1: 'Congratulations on winning the lucky subsidy, <br/>the reward will be automatically distributed to your wallet!',
  2: 'You have triggered the subsidy benefit again, and reward <br/>support has been prepared for you.<br/> Seize the opportunity to counterattack!',
  3: 'Seize the last chance,the subsidy has been issued, go <br/>and turn the tide!',
};

const TIP_TEXT =
  'Every time you recharge, you have the chance to get lucky subsidies. The more you recharge, the more chances you have.';

const HomeYue = (props: {
  step: number;
  reward: number;
  sequentialConsume?: boolean;
}) => {
  const {calcActualSize} = useScreenSize();
  const {step, reward} = props;
  const {goToNext, onClose: closeAll} = useSequentialModalContext();
  const {width} = useResponsiveDimensions();
  const renderAmountImages = (amount: number) => {
    const formattedAmount = amount.toString();
    const digits = formattedAmount.split('');

    return (
      <View style={styles.digitsContainer}>
        {digits.map((char, index) => {
          return (
            <Image
              key={`digit-${index}`}
              source={digitImages[char]}
              style={getNumImageStyle(char)}
            />
          );
        })}
      </View>
    );
  };
  // 如果reward为null，直接返回null不渲染任何内容
  if (reward === null) {
    return null;
  }

  const styles = StyleSheet.create({
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.7)', // Custom overlay background
    },
    stepImageBase: {},
    container: {
      width: width,
      borderRadius: calcActualSize(12),
      padding: calcActualSize(20),
      alignItems: 'center',
    },
    closeButton: {
      position: 'absolute',
      right: calcActualSize(12),
      top: calcActualSize(12),
      zIndex: 1,
      padding: calcActualSize(4),
    },
    closeIcon: {
      width: calcActualSize(24),
      height: calcActualSize(24),
    },
    stepImage1: {
      width: calcActualSize(274),
      height: calcActualSize(41),
      marginBottom: calcActualSize(16),
    },
    stepImage2: {
      width: calcActualSize(334),
      height: calcActualSize(31),
      marginBottom: calcActualSize(16),
    },
    stepImage3: {
      width: calcActualSize(334),
      height: calcActualSize(66),
      marginBottom: calcActualSize(16),
    },
    currImg: {
      width: calcActualSize(48),
      height: calcActualSize(65),
    },
    moneyContainer: {
      position: 'absolute',
      display: 'flex',
      flexDirection: 'row',
      top: calcActualSize(302),
      left: calcActualSize(104),
      width: calcActualSize(210),
    },
    descriptionText: {
      fontSize: calcActualSize(12),
      fontStyle: 'italic',
      color: '#fff',
      textAlign: 'center',
      marginBottom: calcActualSize(16),
    },
    imageContainer: {
      position: 'relative',
      lineHeight: calcActualSize(16),
      top: calcActualSize(-100),
    },
    mainImage: {
      width: width,
      height: calcActualSize(500),
      resizeMode: 'contain',
    },
    moneyText: {
      position: 'absolute',
      top: calcActualSize(295),
      left: calcActualSize(88),
      fontSize: calcActualSize(80),
      color: '#fff',
      fontWeight: 'bold',
    },
    button: {
      width: calcActualSize(300),
      height: calcActualSize(50),
      marginBottom: calcActualSize(20),
      resizeMode: 'contain',
    },
    tipContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      maxWidth: calcActualSize(300),
    },
    tipIcon: {
      width: calcActualSize(22),
      height: calcActualSize(22),
      marginRight: calcActualSize(8),
    },
    tipText: {
      flex: 1,
      fontSize: calcActualSize(8),
      color: '#FF957A',
    },
    digitsContainer: {
      display: 'flex',
      flexDirection: 'row',
    },
    digitImage: {
      width: calcActualSize(48),
      height: calcActualSize(66),
    },
    digitImage0: {
      width: calcActualSize(48),
      height: calcActualSize(66),
    },
    digitImage1: {
      width: calcActualSize(31),
      height: calcActualSize(65),
    },
    digitImage2: {
      width: calcActualSize(47),
      height: calcActualSize(65),
    },
    digitImage3: {
      width: calcActualSize(48),
      height: calcActualSize(66),
    },
    digitImage4: {
      width: calcActualSize(51),
      height: calcActualSize(65),
    },
    digitImage5: {
      width: calcActualSize(47),
      height: calcActualSize(66),
    },
    digitImage6: {
      width: calcActualSize(48),
      height: calcActualSize(66),
    },
    digitImage7: {
      width: calcActualSize(45),
      height: calcActualSize(65),
    },
    digitImage8: {
      width: calcActualSize(50),
      height: calcActualSize(66),
    },
    digitImage9: {
      width: calcActualSize(48),
      height: calcActualSize(66),
    },
    bottomWrapper: {
      position: 'absolute',
      bottom: calcActualSize(100),
    },
  });

  const getStepImageStyle = (currentStep: number) => {
    return [
      styles.stepImageBase,
      currentStep === 1 && styles.stepImage1,
      currentStep === 2 && styles.stepImage2,
      currentStep === 3 && styles.stepImage3,
    ].filter(Boolean); // 过滤掉false值
  };
  const getNumImageStyle = (digit: string) => {
    return [
      digit === '1' && styles.digitImage1,
      digit === '2' && styles.digitImage2,
      digit === '3' && styles.digitImage3,
      digit === '4' && styles.digitImage4,
      digit === '5' && styles.digitImage5,
      digit === '6' && styles.digitImage6,
      digit === '7' && styles.digitImage7,
      digit === '8' && styles.digitImage8,
      digit === '9' && styles.digitImage9,
      digit === '0' && styles.digitImage0,
    ].filter(Boolean); // 过滤掉false值
  };
  const handleRecharge = () => {
    closeAll();
    goTo('Recharge');
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={goToNext} style={styles.closeButton}>
        <Image source={close} style={styles.closeIcon} />
      </TouchableOpacity>
      <Image source={stageImages[step]} style={getStepImageStyle(step)} />
      <div
        style={styles.descriptionText}
        dangerouslySetInnerHTML={{__html: STEP_TEXTS[step]}}
      />
      <View style={styles.imageContainer}>
        <Image style={styles.mainImage} source={basicImg} />
        <View style={styles.moneyContainer}>
          <Image source={currency} style={styles.currImg} />
          {renderAmountImages(reward)}
        </View>
      </View>
      <div onClick={handleRecharge} style={styles.bottomWrapper}>
        <Image style={styles.button} source={btnImg} />
        <View style={styles.tipContainer}>
          <Image source={tip} style={styles.tipIcon} />
          <Text style={styles.tipText}>{TIP_TEXT}</Text>
        </View>
      </div>
    </View>
  );
};

export default HomeYue;
